import { forwardRef, type InputHTMLAttributes } from 'react';

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  invalid?: boolean;
};

const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid = false, className = '', ...rest },
  ref,
) {
  const borderCls = invalid
    ? 'border-rose-500 focus:border-rose-500 focus:ring-rose-500/20'
    : 'border-ink-200 focus:border-sage-500 focus:ring-sage-500/30';
  return (
    <input
      ref={ref}
      className={`w-full bg-cream-50 border ${borderCls} rounded-lg px-3.5 py-2.5 text-sm text-ink-900 placeholder:text-[#a89d8a] focus:outline-none focus:ring-2 transition-colors ${className}`}
      {...rest}
    />
  );
});

export default Input;
